<template>
	<div class="table-component">
		<div class="table-wrapper" v-if="parameters.length !== 0">
			<div class="table" ref="tables" v-dragscroll v-bind:style="tableStyle" @scroll="componentScroll">
				<div class="thead" data-no-dragscroll>
					<div class="thead__column-index">
						<div class="thead__empty"><span></span></div>
					</div>
					<div class="thead__content">
						<div class="thead__row" id="thead__row">
							<div 
								class="thead__item" 
								ref="thead__item" 
								v-for="( value, key ) in buildParameters" 
								:key="key"
								:class="{ 'selectable': value._id === selectable }"
							>
								<div v-if="value.latex" v-katex="value.latex"></div>
								<div v-if="value.units" v-katex="value.units"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="tbody" ref="tbody">
					<div class="tbody__column-index">
						<div class="tbody__index" v-for="( item, idx ) in getRowsCP" :key="idx">
							{{ idx + 1 }}.
						</div>
					</div>
					<div class="tbody__content">
						<div class="tbody__row" id="tbody__row" v-for="( item, key ) in getRowsCP" :key="key">
							<div
								class="tbody__item"
								:class="{ 
									'selectable': field._id === selectable,
									'selected': (selectedValue === item && field._id === selectable)
								}"
								ref="tbody__item"
								v-for="( field, idx ) in buildParameters"
								v-bind:key="idx"
								@click="selectValue( item )"
							>
								<template v-if="field.data[item].value">
									
									<template v-if="field.data[item].datatype === 'image'">
										<div class="link-img">
											<img :src="field.data[item].value">
										</div>
									</template>
									<template v-else-if="field.data[item].datatype === 'latex'">
										<div v-katex="field.data[item].value"></div>
									</template>
									<template v-else>
										{{ field.data[item].value }}
									</template>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="table-wrapper__mask" ref="mask">
				{{ labels.to_scroll_the_table }}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "TableIframe",
		data() {
			return {
				loadCols: false,
				loadRows: false,
				hasNextRowPosition: false,
				total: 1,
				labels: {
					to_scroll_the_table: "To scroll the table, please use 'Ctrl' for horizontal scrolling and 'Alt' for Vertical scrolling",
				},
				visibleRows: [],
				pressedKey: false,
				columnsNumbers: 0,
				tableStyle: {
					'--column_width': '200px',
				},
				polygonCellWidth: 0,
				polygonCellHeight: 0,
				settings: {
					visited: ['1x1'],
					columns: {
						1: {
							start: 0, // width start
							end: 200 * this.parametersPerPosition // width end
						}
					},
					rows: {
						1: {
							start: 0, // height start
							end: 50 * this.rowsPerPosition // height end
						}
					}
				},
				currentPosition: {
					row: 1,
					column: 1,
				}
			}
		},
		props: {
			parameters: {
				type: Array,
				default: () => []
			},
			rows: {
				type: Array,
				default: () => []
			},
			values: {
				type: [Object, Array],
				default: () => []
			},
			removeRow: {
				type: Function,
				default: () => []
			},
			getNextTablePosition: {
				type: Function,
				default: () => []
			},
			getChangesRevisionsCount: {
				type: Function,
				default: () => []
			},
			tableLoopKey: {
				type: Number,
				default: Date.now()
			},
			hasNextParameterPosition: {
				type: Boolean
			},
			rowsPerPosition: {
				type: Number,
				default: 20
			},
			parametersPerPosition: {
				type: Number,
				default: 16
			},
			rowPosition: {
				type: Number,
				default: 1
			},
			parameterPosition: {
				type: Number,
				default: 0
			},
			itemData: {
				type: Object,
				default: () => {}
			},
			itemKey: {
				type: String,
				default: ''
			},
			selectValue: {
				type: Function,
				default: () => {}
			},
			selectable: {
				type: String,
				default: ''
			},
			selectedValue: {
				type: [String, Number],
				default: () => {}
			},
			tableScroll: {
				type: Function,
				default: () => {}
			},
			hasNextCols: {
				type: Boolean,
			},
		},
		computed: {
			buildParameters() {
				let output = [];
				let columns = {};
				
				for ( const parameterId in this.values ) {
					if ( Object.hasOwnProperty.call( this.values, parameterId ) ) {
						const tablevalue = this.values[parameterId];
						let column = {};
						for ( let i = 0; i < this.visibleRows.length; i++ ) {
							const rowKey = this.visibleRows[i];
							column[rowKey] = {};
							if ( tablevalue.data && tablevalue.data[rowKey] ) {
								let idx = this.parameters?.findIndex( el => el._id === parameterId );

								if ( idx >= 0 ) {
									column[rowKey].datatype = this.parameters[idx].datatype;
								}

								column[rowKey].value = tablevalue.data[rowKey].value;
								column[rowKey].value_id = tablevalue.data[rowKey]._id;
							} else {
								column[rowKey].value = '';
								column[rowKey].value_id = null;
							}
						}
						columns[parameterId] = column;
					}
				}
				if ( this.parameters.length !== 0 && this.values.length !== 0 ) {
					this.parameters.forEach( parameter => {
						for ( let prop in this.values ) {
							if ( parameter._id === this.values[prop].parameter ) {
								parameter.table_value_id = this.values[prop]._id;
								parameter.data = columns[parameter._id];
								output.push( parameter );
							}
						}
					} );
				}
				
				return output;
			},
			getRowsCP() {
				this.getRowsMT();
				return this.visibleRows;
			}
		},
		methods: {
			getRowsMT() {
				let end = this.rowsPerPosition + (this.rowsPerPosition * (this.rowPosition - 1));

				let visibleRows = this.rows;
				visibleRows = visibleRows.slice( 0, end );

				if ( visibleRows.length !== this.rows.length ) {
					this.hasNextRowPosition = true;
				} else {
					this.hasNextRowPosition = false;
				}
				this.visibleRows = [ ...visibleRows ];
			},
			horizontalScroll( e ) {
				let element = this.$refs.tables;
				e = window.event || e;
				e.preventDefault();
				element.scrollLeft -= (e.wheelDelta || -e.detail);
			},
			scrollEvent( event ) {
				event.preventDefault();
				if ( !this.pressedKey && this.$refs.mask ) {
					this.$refs.mask.style.display = 'flex';
					setTimeout( () => {
						this.$refs.mask.style.display = 'none'
					}, 2000 );
				}
			},
			buildPolygon() {
				let polygonRows = Math.ceil( this.rows.length / this.rowsPerPosition );
				let polygonColumns = Math.ceil( this.parameters.length / this.parametersPerPosition );
				let polygonCellWidth = 200 * this.parametersPerPosition;
				let polygonCellHeight = 50 * this.rowsPerPosition;

				for (let i = 1; i <= polygonRows; i++ ) {
					this.settings.rows[i] = { start: ( polygonCellHeight + 75 ) * ( i - 1 ) };
					this.settings.rows[i].end = ( polygonCellHeight + 75 ) * i;
				}

				for (let i = 1; i <= polygonColumns; i++ ) {
					this.settings.columns[i] = { start: ( polygonCellWidth + 100 ) * ( i - 1 ) };
					this.settings.columns[i].end =  ( polygonCellWidth + 100 ) * i;
				}
			},
			getPolygonCell( borderL, borderR, borderT, borderB ) {
				let output = { columns: [], rows: [] };
				for (const index in this.settings.columns) {
					if (
						(
							this.settings.columns[index].start <= borderL &&
							this.settings.columns[index].end >= borderR
						) ||
						(
							this.settings.columns[index].start <= borderR &&
							this.settings.columns[index].end >= borderL
						)
					) {
						output.columns.push( index );
					}
				}
				for (const index in this.settings.rows) {
					if (
						(
							this.settings.rows[index].start <= borderT &&
							this.settings.rows[index].end >= borderB
						) ||
						(
							this.settings.rows[index].start <= borderB &&
							this.settings.rows[index].end >= borderT
						)
					) {
						output.rows.push( index );
					}
				}
				
				output.columns.forEach( column => {
					output.rows.forEach( row => {
						if ( !this.settings.visited.includes( `${column}x${row}` ) ) {
							this.settings.visited.push(`${column}x${row}`)
							this.getNextTablePosition( {
								parameterPosition: column,
								rowPosition: row
							}, this.itemData, this.itemKey );
						}
					})
				})
			},
			componentScroll( e ) {
				if ( this.tableScroll ) this.tableScroll(e);

				if (e.target.scrollLeft >= (e.target.scrollWidth - e.target.offsetWidth) && this.hasNextCols) {
					this.loadCols = true;
				} else this.loadCols = false;

				if (e.target.scrollTop >= (e.target.scrollHeight - e.target.offsetHeight) && this.hasNextParameterPosition) {
					this.loadRows = true;
				} else this.loadRows = false;
			},
			changeCursorType() {
				let self = this;
				let fn = function () {

					if ( typeof self.$refs.tables === 'undefined' ) {
						return;
					}

					clearInterval( changeCursorTypeInterval );

					let element = self.$refs.tables;
					if ( element ) {
						element.addEventListener( "mousedown", function () {
							element.style.cursor = 'grabbing'
							element.addEventListener( "mouseup", function () {
								element.style.cursor = 'grab'
							} )
							element.addEventListener( "mouseout", function () {
								document.addEventListener( "mouseup", function () {
									element.style.cursor = 'grab'
								} )
							} )
						} )
					}
				};

				let changeCursorTypeInterval = setInterval( fn, 500 );
			},
			triggerPressedKey() {
				let self = this;
				let fn = function () {

					if ( typeof self.$refs.tables === 'undefined' ) {
						return;
					}

					clearInterval( triggerPressedKeyInterval );

					let element = self.$refs.tables;
					if ( element ) {
						element.addEventListener( 'mousewheel', self.scrollEvent, false );

						document.addEventListener( 'keydown', ( event ) => {
							const keyName = event.key;
							if ( keyName === 'Control' ) {
								self.pressedKey = true;
								if ( self.$refs.mask ) {
									self.$refs.mask.style.display = 'none'
								}
								element.addEventListener( 'mousewheel', self.horizontalScroll, false );
							}
							if ( keyName === 'Alt' || keyName === 'Meta' ) {
								event.preventDefault();
								self.pressedKey = true;
								if ( self.$refs.mask ) {
									self.$refs.mask.style.display = 'none'
								}
								element.removeEventListener( 'mousewheel', self.scrollEvent, false );
							}
						}, false );

						document.addEventListener( 'keyup', ( event ) => {
							const keyName = event.key;
							if ( keyName === 'Control' ) {
								self.pressedKey = false;
								element.removeEventListener( 'mousewheel', self.horizontalScroll, false );
							}
							if ( keyName === 'Alt' ) {
								event.preventDefault();
								self.pressedKey = false;
								element.addEventListener( 'mousewheel', self.scrollEvent, false );
							}
						}, false );
					}
				};

				let triggerPressedKeyInterval = setInterval( fn, 500 );
			},
		},
		mounted() {
			this.changeCursorType();
			this.triggerPressedKey();
		},
		watch: {
			tableLoopKey() {
				this.buildParameters;
			},
			rowsPerPosition() {
				this.buildPolygon();
			},
			parametersPerPosition() {
				this.buildPolygon();
			},
			loadRows() {
				if ( this.loadRows ) {
					this.$emit( 'update-row-position', { 
						key: this.itemKey, 
						data: { rowPosition: this.rowPosition + 1 } 
					} );

					this.settings.visited.push(`${this.parameterPosition}x${this.rowPosition}`);

					this.getRowsCP;
					this.getNextTablePosition( {
						parameterPosition: this.parameterPosition,
						rowPosition: this.rowPosition + 1
					}, this.itemData, this.itemKey );
				}
			},
			loadCols() {
				if ( this.loadCols ) {
					this.$emit( 'update-parameter-position', {
						key: this.itemKey,
						data: { parameterPosition: this.parameterPosition + 1 }
					} );

					this.settings.visited.push(`${this.parameterPosition}x${this.rowPosition}`);

					this.getNextTablePosition( {
						parameterPosition: this.parameterPosition + 1,
						rowPosition: this.rowPosition
					}, this.itemData, this.itemKey );
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.table-component {
		/*width: max-content;*/
		max-width: 100%;
		overflow: hidden;

		.table-wrapper {
			position: relative;
			height: max-content;
			/*width: max-content;*/

			.table {
				position: relative;
				max-height: 620px;
				width: 100%;
				/*max-width: max-content;*/
				overflow: auto;

				cursor: grab;
				//margin-bottom: 0;
				background-color: #ffffff;
				transform: scale(1.0000001);
				margin-bottom: -12px;
				padding-bottom: 12px;

				&::-webkit-scrollbar {
					width: 4px;
					height: 4px;
				}

				&::-webkit-scrollbar-track {
					background: #E7E7E7;
					-webkit-border-radius: 5px;
					-moz-border-radius: 5px;
					border-radius: 5px;
				}

				&::-webkit-scrollbar-thumb {
					background-color: #14AAF5;
					-webkit-border-radius: 5px;
					-moz-border-radius: 5px;
					border-radius: 5px;
				}

				.thead {
					position: sticky;
					top: 0;
					z-index: 1;
					display: flex;

					&__column-index {
						// height: 72px;
						/*padding-bottom: 70px;*/
						background-color: #F6F6F6;
					}

					&__empty {
						background-color: #F6F6F6;
						border: 1px solid #E7E7E7;
						width: 60px;
						height: 100%;
					}

					&__content {
						width: 100%;
					}

					&__row {
						width: max-content;
						/*width: 100%;*/
						display: flex;
					}

					&__item {
						width: var(--column_width);
						min-width: 200px;
						background-color: #F6F6F6;
						/*flex: 1 1 auto;*/
						min-height: 50px;
						line-height: 50px;
						// padding-bottom: 70px;
						text-align: center;
						border: 1px solid #E7E7E7;
						white-space: nowrap;
						
						transition: all .5s ease;
						display: flex;
						flex-direction: column;

						&.selectable {
							background: #9ec7e0;
						}

						& > div {
							overflow-x: auto;
							overflow-y: hidden;
							display: flex;
							justify-content: center;
							align-items: center;
							min-height: 50px;

							&:first-child {
								flex-grow: 1;
							}

							&:not(:first-child) {
								flex: 0 0 50%;
							}

							&::-webkit-scrollbar {
								height: 4px;
							}

							&::-webkit-scrollbar-track {
								background: #E7E7E7;
								-webkit-border-radius: 0;
								-moz-border-radius: 0;
								border-radius: 0;
							}

							&::-webkit-scrollbar-thumb {
								background-color: #14AAF5;
								-webkit-border-radius: 5px;
								-moz-border-radius: 5px;
								border-radius: 5px;
							}
						}

						::v-deep .katex {
							padding-left: 20px;
							padding-right: 20px;
						}

						::v-deep .pim-card-head,
						::v-deep .pim-card-body {
							min-width: 1100px;
						}
					}
				}

				.tbody {
					min-width: max-content;
					display: flex;

					&__column-index {
						position: sticky;
						left: 0;
						color: #212529;

						span {
							padding: 5px;

							svg {
								font-size: 1rem;
								color: #7f8c8d;
							}

							&:hover {
								opacity: 0.7;
								cursor: pointer;
							}
						}
					}

					&__index {
						display: flex;
						align-items: center;
						justify-content: center;
						padding-left: 5px;
						min-height: 65px;
						width: 60px;
						border: 1px solid #E7E7E7;
						background-color: #F6F6F6;
					}

					&__content {
						width: 100%;
					}

					&__row {
						width: 100%;
						/*width: max-content;*/
						display: flex;
					}

					&__item {
						width: var(--column_width);
						min-width: 200px;
						/*flex: 1 1 auto;*/
						height: 65px;
						padding-left: 10px;
						padding-right: 10px;
						line-height: 40px;
						text-align: center;
						border: 1px solid #E7E7E7;
						overflow-x: auto;
						overflow-y: hidden;
						transition: all .5s ease;
						align-items: center;
						display: flex;
						justify-content: center;

						&::-webkit-scrollbar {
							height: 4px;
						}

						&::-webkit-scrollbar-track {
							background: #E7E7E7;
							-webkit-border-radius: 0;
							-moz-border-radius: 0;
							border-radius: 0;
						}

						&::-webkit-scrollbar-thumb {
							background-color: #14AAF5;
							-webkit-border-radius: 5px;
							-moz-border-radius: 5px;
							border-radius: 5px;
						}

						::v-deep .pim-card-head,
						::v-deep .pim-card-body {
							min-width: 1100px;
						}

						a {
							cursor: unset;
						}

						&.selectable {
							background: #e5eff6;
							cursor: pointer;

							&:hover {
								background: #fff;
							}
						}

						&.selected {
							background: #9ec7e0;

							&:hover {
								background: #9ec7e0;
							}
						}
					}

					&__item-link {
						color: #68696D;
						white-space: nowrap;
						display: flex;
						align-items: center;
						justify-content: center;

						svg {
							color: #B0AFB5;
						}

						&:hover {
							text-decoration: none;
							opacity: 0.8;
						}

					}
					.link-img {
						padding: 5px;
						border-radius: 4px;
						box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.07);
						
						img {
							display: block;
							max-height: 50px;
							width: auto;
						}
					}

					&__item-btn {
						width: 30px;
						height: 30px;
						padding: 5px 10px;
						display: flex;
						margin: 8px auto 7px;
						justify-content: center;
						align-items: center;
					}
				}
			}

			&__mask {
				display: none;
				position: absolute;
				z-index: 2;
				height: 100%;
				width: 100%;
				top: 0px;
				background-color: rgba(0, 0, 0, 0.5);
				color: #212529;
				font-size: 2.5rem;
				padding: 100px;
				text-align: center;
				align-items: center;
				justify-content: center;
			}
		}
	}

</style>